import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { cloudStorageAPI } from "api/api/cloudStorageApi/cloudStorageApi";
import { GetCloudStorageByIdParams } from "api/api/cloudStorageApi/types";

export const getCloudStorageById = createAsyncThunk<
  Blob,
  GetCloudStorageByIdParams
>("cloudStorage/download", async (params, { rejectWithValue }) => {
  try {
    const data = await cloudStorageAPI.getCloudStorageById(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting photo",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while getting photo", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
